export default __webpack_public_path__ + "static/media/promoImolaNew_pasada.e4322fd8.webp";